import { useLocale } from '@op/opds.opux';
import React from 'react';
import { IconLinkInternal } from '@op/opds.opux-icons/navigation';
import { IconList } from '@op/opds.opux-icons/action';
import { Message } from '@messageformat/react';
import { CourseNumber } from '../interfaces/CoursePage';
import {
  analyticsActionGroup,
  analyticsActionName,
  analyticsPhaseName,
  sendAnalyticsAction,
} from '../util/analytics';
import LinkButton from './LinkButton';
import routes from '../messages/routes';
import styles from './CourseNavigation.module.scss';

interface CourseNavigationProps {
  allowNext: boolean;
  fromCourseNumber: CourseNumber;
}

const CourseNavigation: React.FC<CourseNavigationProps> = ({
  fromCourseNumber,
  allowNext,
}) => {
  const locale = useLocale();
  const { courses } = routes[locale];

  return (
    <div className={styles.container}>
      {allowNext && (
        <LinkButton
          primary
          icon={IconLinkInternal}
          iconPos="right"
          size="large"
          to={`${courses}/${fromCourseNumber + 1}`}
          onClick={() => {
            sendAnalyticsAction(
              analyticsActionName.COURSE_COMPLETED_NEXT,
              analyticsActionGroup.CLICK,
              analyticsPhaseName[fromCourseNumber],
            );
          }}
        >
          <Message id="next_course_button" />
        </LinkButton>
      )}
      <LinkButton
        icon={IconList}
        size="large"
        to={courses}
        onClick={() => {
          sendAnalyticsAction(
            analyticsActionName.COURSE_COMPLETED_BACK,
            analyticsActionGroup.CLICK,
            analyticsPhaseName[fromCourseNumber],
          );
        }}
      >
        <Message id="back_to_all_courses_button" />
      </LinkButton>
    </div>
  );
};

export default CourseNavigation;
